<template>
	<LayoutList>
		<template slot="header">
			<h1>Members</h1>
			<router-link
                to="/members/create"
                class="btn btn--primary"
                v-if="can('createMembers')"
            >
                Member Setup
            </router-link>
		</template>
		<template slot="filters">
			<FormControlCountry
                name="member"
                v-model="filters.country"
                placeholder="Select..."
                label="Country"
            />
		</template>
		<GridMembers :filters="filters" />
	</LayoutList>
</template>
<script>
	import { mapGetters } from 'vuex';
	import LayoutList from '../Layout/LayoutList';
	import FormControlRegion from '../Form/Control/FormControlRegion';
	import GridMembers from '../Grid/GridMembers';
    import FormControlCountry from '@components/Form/Control/FormControlCountry.vue';

	export default {
		name: 'MemberList',
		components: {
            FormControlCountry,
			LayoutList,
			FormControlRegion,
			GridMembers
		},
		data() {
			return {
				filters: {
					query: null,
					region: null,
					country: null,
				}
			}
		},
		computed: {
			...mapGetters([ 'can', 'members' ]),
		},
		watch: {
			filters: {
				deep: true,
				handler() {
					this.$store.commit('modifyMembers', {
						query: this.filters.query,
						region: this.filters.region,
                        countries: this.filters.countries
					});
				}
			}
		},
		methods: {
			load() {
				this.filters.query = this.members.query;
				this.filters.region = this.members.region;
				this.filters.countries = this.members.countries;
			},
		},
		created() {
			this.load();
		}
	}
</script>
